const getEnv = require("../helpers/env").getEnv;

const configLoginKeys = {
  linkedIn: {
    client_id: process.env.LINKEDIN_CLIENT_ID,
    client_secret: process.env.LINKEDIN_CLIENT_SECRET,
    redirect_uri: process.env.BASE_URL + "/linkedinCallback",
    scope: ["r_emailaddress", "r_liteprofile"],
    provider: "LINKEDIN"
  },
  backEnd_Auth_Url: process.env.AXIOS_USER_MANAGEMENT + "/authenticate",
  appleSignIn_Auth_Url: process.env.AXIOS_USER_MANAGEMENT + "/authenticateApple",
  appleSignIn: {
    client_id: getEnv("APPLE_CLIENT_ID"),
    scope: 'name email',
    redirect_uri: getEnv("BASE_URL"),
    provider: "APPLE",
    platform: "Web"
  },
  googleSignIn: {
    client_id: process.env.GOOGLE_CLIENT_ID,
    client_secret: process.env.GOOGLE_CLIENT_SECRET,
    redirect_uri: process.env.BASE_URL + "/googleCallback",
    provider: "GOOGLE",
    platform: "Web"
  },
};

module.exports = configLoginKeys;
